export class Step5 {

    public getspan12 = 'form.mapa_at.getspan12';
    public getaddlot = 'form.mapa_at.getaddlot';
    public getdeletelot = 'form.mapa_at.getdeletelot';
    public getinfructueux = 'form.mapa_at.getinfructueux';
    public getsanssuite = 'form.mapa_at.getsanssuite';
    public getattribue = 'form.mapa_at.getattribue';
    public getnumlot = 'form.mapa_at.getnumlot';
    public getdescription = 'form.mapa_at.getdescription';
    public getspan17 = 'form.mapa_at.getspan17';
    public getspan19 = 'form.mapa_at.getspan19';


}
